<div class="relative flex items-center justify-center w-full h-full">
  <!-- devices -->
  <!-- ngx-scanner-qrcode -->
  <ngx-scanner-qrcode
    #action="scanner"
    class="backdrop-blur-xl"
    [config]="config"
    (event)="onEvent($event, action)"
  ></ngx-scanner-qrcode>

  <div
    class="absolute flex items-center justify-center w-full p-20 text-white transform -translate-x-1/2 -translate-y-1/2 h-1/2 top-1/2 left-1/2"
  >
    <div class="relative w-full h-full max-h-60 max-w-60">
      <div
        class="absolute top-0 left-0 p-5 border-4 border-b-0 border-r-0 border-white rounded-tl-xl"
      ></div>
      <div
        class="absolute top-0 right-0 p-5 border-4 border-b-0 border-l-0 border-white rounded-tr-xl"
      ></div>
      <div
        class="absolute bottom-0 left-0 p-5 border-4 border-t-0 border-r-0 border-white rounded-bl-xl"
      ></div>
      <div
        class="absolute bottom-0 right-0 p-5 border-4 border-t-0 border-l-0 border-white rounded-br-xl"
      ></div>
    </div>
  </div>

  <button
    class="absolute p-1 text-white rounded-full top-5 left-5 bg-white/30 backdrop-blur-sm"
    (click)="close()"
		*ngIf="started()"
  >
    <app-close-icon></app-close-icon>
  </button>

  <div
    class="absolute left-0 z-50 flex items-center justify-center w-full p-5 space-x-5 bottom-10 h-14"
  >
    <button
      class="p-2 text-white rounded-full bg-white/30 backdrop-blur-sm"
      (click)="action.isTorch = !action.isTorch; handle(action, 'torcher')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M13.232 2.287A.75.75 0 0 1 13.75 3v6.25H19a.75.75 0 0 1 .607 1.191l-8 11a.75.75 0 0 1-1.357-.44v-6.25H5a.75.75 0 0 1-.607-1.192l8-11a.75.75 0 0 1 .839-.272"
          clip-rule="evenodd"
        />
      </svg>
    </button>
    <button (click)="toggleCamera()" class="p-2 text-white rounded-full bg-white/30 backdrop-blur-sm">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4.05 11a8 8 0 1 1 .5 4m-.5 5v-5h5"
        />
      </svg>
    </button>
  </div>
  <br />
</div>
